import * as React from "react";
import { useStreamingText } from "@/hooks/useStreamingText";
import type { PromptResult } from "../types";

interface UseTypewriterProgressProps {
  processing: boolean;
  content: string;
  speed: number;
  promptResult: PromptResult;
  onPromptTypewriterEnded: (prompt: PromptResult) => void;
  onScroll?: () => void;
}

export const useTypewriterProgress = ({
  processing,
  content,
  speed,
  promptResult,
  onPromptTypewriterEnded,
  onScroll,
}: UseTypewriterProgressProps) => {
  const safeSpeed = Math.max(1, speed);
  const charsPerFrame = Math.max(1, Math.round(16 / safeSpeed));
  const typedContent = useStreamingText(processing ? content : "", processing, charsPerFrame);

  const progressPercentage = processing && content ? Math.round((typedContent.length / content.length) * 100) : 0;

  React.useEffect(() => {
    if (processing && typedContent === content) {
      onPromptTypewriterEnded(promptResult);
    } else if (processing && typedContent !== content) {
      onScroll?.();
    }
  }, [typedContent, content, promptResult, onPromptTypewriterEnded, processing, onScroll]);

  return {
    typedContent,
    progressPercentage,
  };
};
